<template>
  <div class="simple-pie-chart">
    <apexchart v-if="ApexChartsComponent" :is="ApexChartsComponent" type="bar" height="200" :options="chartOptions"
               :series="series"/>
  </div>
</template>

<script lang="ts" setup>
import {defineComponent, ref, onMounted, computed, watch} from 'vue';
import {dateRange} from "../../composables/getFinancial";

const computedCategories = ref([]);
const chartOptions = ref({
  chart: {
    type: 'bar',
    height: 200,
    events: {
      mounted: (chart: any) => {
        console.log('Chart mounted', chart);
        chart.windowResizeHandler();
      }
    }
  },
  plotOptions: {
    bar: {
      horizontal: true,
      dataLabels: {
        position: 'top',
      },
    }
  },
  dataLabels: {
    enabled: false,
    offsetX: -18,
    style: {
      fontSize: '12px',
      colors: ['#fff']
    }
  },
  stroke: {
    show: true,
    width: 1,
    colors: ['#fff']
  },
  xaxis: {
    labels: {
      formatter: function (value: any) {
        return `€${value.toLocaleString()}`;
      }
    },
    categories: computedCategories.value,
  },
  legend: {
    position: 'bottom',
    horizontalAlign: 'left',
    markers: {
      shape: 'circle'
    }
  },
  labels: ['Omzet', 'Kosten', 'Winst/Verlies'],
  colors: ['#FFA5CB', '#E697FF', '#63ABFD']
});

watch(dateRange, (newValue) => {
  console.log("dateRange changed");
  const range = new Date(newValue);
  computedCategories.value = [
    range.toLocaleString('en', {month: 'short'}),
    new Date(range.setMonth(range.getMonth() - 1)).toLocaleString('en', {month: 'short'}),
    new Date(range.setMonth(range.getMonth() - 1)).toLocaleString('en', {month: 'short'}),
  ];
  console.log(computedCategories.value);
  console.log(chartOptions.value.xaxis.categories);
  chartOptions.value = {
    ...chartOptions.value,
    xaxis: {
      ...chartOptions.value.xaxis,
      categories: computedCategories.value,
    },
  };
  console.log(chartOptions.value.xaxis.categories);
}, {immediate: true});

const ApexChartsComponent = ref(null);

const props = defineProps({
  series: {
    type: Array,
    required: true,
  },
});
// Dynamically import VueApexCharts on client-side
onMounted(() => {
  import('vue3-apexcharts').then((module) => {
    ApexChartsComponent.value = module.default;
  });
});

</script>
<style scoped>
.simple-pie-chart {
  display: block;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}
</style>
